var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart_box",style:({ width: '93%', height: _vm.barBoxHeight + 'px' })},[_c('div',{ref:"barChartRef",style:({ width: '100%', height: _vm.barChartHeight + 'px' })})])
}
var staticRenderFns = []

export { render, staticRenderFns }